import { render, staticRenderFns } from "./QuoteLanguageSelector.vue?vue&type=template&id=55f06d7e&"
import script from "./QuoteLanguageSelector.vue?vue&type=script&lang=ts&"
export * from "./QuoteLanguageSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports